<template>
  <v-dialog v-model="show" max-width="300">
    <v-card class="animated fadeIn pa-3" v-if="selectedTask && selectedUser">
      <v-layout row wrap mt-1 mb-2 justify-center>
        <v-flex xs2>
          <div v-lazy-container="{ error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg', loading: 'https://s3.amazonaws.com/konselior/blankwhats.jpg' }">
                <v-avatar size="30" v-if="selectedUser.celular && selectedUser.celular.whatsapp"><img class="avatarImg" :data-src="selectedUser.celular.whatsapp.picture"></v-avatar>
                <v-avatar size="30" v-if="!selectedUser.celular || !selectedUser.celular.whatsapp"><img class="avatarImg" :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'"></v-avatar>
              </div>
        </v-flex>

        <v-flex xs10 class="trunk">
          <v-subheader :to="`/contato/${selectedUser.id}`" @click.stop="show=false">
            {{selectedUser.nome}} {{selectedUser.sobrenome}}
            <v-icon v-if="selectedUser.primeiraCompra" small color="warning" class="ml-1">star</v-icon>
            <v-icon v-if="selectedUser.best" small color="#099AB1" class="ml-1">favorite</v-icon>
            <v-spacer></v-spacer>
            <v-btn icon small flat :to="`/contato/${selectedUser.id}`" @click.stop="show=false">
              <v-icon small>chevron_right</v-icon>
            </v-btn>
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout row wrap justify-center my-2>
        <v-flex xs1 v-if="!isEditing">
          <v-icon small :class="`${selectedTask.situacao}`">fas fa-clock</v-icon>
        </v-flex>
        <v-flex xs11>
          <v-subheader v-if="!isEditing">{{selectedTask.due | formattedDate}}</v-subheader>
          <v-menu v-if="isEditing">
            <v-text-field
              :value="formattedCalendar"
              slot="activator"
              class="fontResize"
            ></v-text-field>
            <v-date-picker v-model="editedDate" header-color="#099AB1" width="250"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center>
        <div
          v-if="!isEditing"
          class="mb-3"
          style="width: 100%; height: 100px; overflow-y: scroll;"
        >{{selectedTask.description}}</div>
        <v-textarea
          v-if="isEditing"
          v-model="selectedTask.description"
          name="input-7-1"
          value
          rows="5"
        ></v-textarea>
      </v-layout>
      <v-card-actions>
        <div style="margin: 0 auto">
          <v-btn
            v-if="!deleteDialog && !isEditing"
            small
            color="primary"
            flat
            @click.stop="editarTarefa"
          >
            <span class="text-lowercase">editar</span>
          </v-btn>
          <v-btn
            v-if="!deleteDialog && !isEditing"
            small
            color="primary"
            flat
            @click.stop="deleteDialog = !deleteDialog"
          >
            <span class="text-lowercase">deletar</span>
          </v-btn>

          <div v-if="deleteDialog" class="animated fadeIn">
            <v-layout mt-2 justify-space-around>
              <v-subheader>Deseja deletar essa tarefa?</v-subheader>
            </v-layout>
            <v-layout mt-2 justify-space-around>
              <v-btn color="#f7776e" icon small @click="deleteDialog = false">
                <v-icon small color="white">close</v-icon>
              </v-btn>
              <v-btn color="#95d097" icon small @click="deletarTarefa">
                <v-icon small color="white">check</v-icon>
              </v-btn>
            </v-layout>
          </div>

          <div v-if="isEditing" class="animated fadeIn">
            <v-layout mt-2 justify-space-around>
              <v-subheader>Deseja salvar as alterações?</v-subheader>
            </v-layout>
            <v-layout mt-2 justify-space-around>
              <v-btn color="#f7776e" icon small @click="isEditing = false">
                <v-icon small color="white">close</v-icon>
              </v-btn>
              <v-btn color="#95d097" icon small @click="alterarTarefa">
                <v-icon small color="white">check</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </div>
      </v-card-actions>

      <v-divider></v-divider>

      <v-layout justify-center>
        <v-flex xs4 ml-4>
          <v-btn
            icon
            :href="selectedUser.celular | whatsappUrl"
            target="_blank"
            :disabled="!selectedUser.celular.whatsapp || !selectedUser.celular.whatsapp.code == '001'"
          >
            <v-icon color="#34af23">fab fa-whatsapp</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs4>
          <v-btn icon :href="selectedUser.celular | telHref">
            <v-icon class="iconList">fas fa-phone</v-icon>
          </v-btn>
        </v-flex>

        <!-- <v-flex xs3>
          <v-btn
            icon
            :disabled="!selectedUser.email || !selectedUser.email.value"
            :href="selectedUser.email | mailTo"
          >
            <v-icon class="iconList">far fa-envelope</v-icon>
          </v-btn>
        </v-flex> -->

        <v-flex xs4>
          <v-btn icon>
            <v-icon
              :color="selectedTask.end ? '#95d097' : '#e0e0e0'"
              @click.stop="updateStatus(selectedTask)"
            >check</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import { APIService } from '@/resources/campanha.js';
import { mapState, mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/event-bus.js';
import format from 'date-fns/format';
import {
  distanceInWordsToNow,
  isFuture,
  isPast,
  endOfDay,
  addHours,
} from 'date-fns';

const api = new APIService();
export default {
  data() {
    return {
      deleteDialog: false,
      isEditing: false,
      editedDate: null,
    };
  },
  filters: {
    formatCategorias: value => (value && value.length > 1 ? 'Multiplas' : value ? value[0] : null),
    fullPhone: (value) => {
      if (!value) return 'Nao informado';
      if (value.valid === false) return value.original;
      return `+55 (${value.phoneArea}) ${value.phone}`;
    },
    whatsappUrl: (value) => {
      if (!value) return '';
      return `http://api.whatsapp.com/send?phone=${value.countryCode}${value.phoneArea}${value.phone}`;
    },
    telHref: value => `tel:+${value.countryCode}${value.phoneArea}${value.phone}`,
    mailTo: (value) => {
      if (!value) return '';
      return `mailto:+${value.value}`;
    },

    formattedDate: item => (item ? format(item, 'DD/MM/YYYY') : 'Não Informado'),
  },
  computed: {
    ...mapState(['selectedTask', 'selectedUser']),

    formattedCalendar() {
      return this.editedDate ? format(this.editedDate, 'DD/MM/YYYY') : '';
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.isEditing) this.isEditing = false;
        this.$emit('input', value);
      },
    },
  },
  props: {
    value: Boolean,
  },

  methods: {
    async alterarTarefa() {
      this.selectedTask.due = this.editedDate;
      await api.updateTask(this.selectedTask);
      await this.$store.dispatch('carregarPerfil', { user: this.$auth.user });
      this.show = false;
      this.isEditing = false;
      this.emitSnackBar();
    },
    editarTarefa() {
      this.isEditing = true;
      this.editedDate = format(this.selectedTask.due, 'YYYY-MM-DD');
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Operação finalizada com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async deletarTarefa() {
      await api.deleteTask(this.selectedTask);
      await this.$store.dispatch('carregarPerfil', { user: this.$auth.user });
      this.show = false;
      this.deleteDialog = false;
      this.emitSnackBar();
    },
    async updateStatus(item) {
      if (item.end) {
        item.end = null;
        api.updateTask(item);
        this.emitSnackBar();
      } else {
        item.end = new Date();
        api.updateTask(item);
        this.emitSnackBar();
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}
.v-card__actions .v-btn + .v-btn {
  margin: 0px;
}
.v-text-field{
  margin-top: 0px;
  padding-top: 0px;
}
.v-card .v-card__actions {
  margin: 0px;
  padding-top: 0px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}
.v-subheader {
  padding: 0px;
  height: 25px;
}
.iconList {
  font-size: 18px;
  color: #099AB1 !important;
}
.EMDIA {
  color: #ffc266 !important;
}
.ATRASADO {
  color: #f7776e !important;
}
.CONCLUIDO {
  color: #95d097 !important;
}
.v-btn--active {
  border-bottom: 0px !important;
}
.fontResize{
  font-size: 12px !important;
}
</style>
